//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet } from '../../axios/axios.js'
import { mapGetters } from 'vuex'

import { downloadFile } from '../../components/helpers.js'
import CatalogsBaseForm from '../../pages/main/sections/Catalogs/CatalogsBaseForm.vue'

export default {
  components: {
    CatalogsBaseForm
  },
  props: {
    type: {
      type: String,
      default: 'common' // 'polevoy'
    }
  },
  data: function () {
    return {
      loading: false,
      url: null,
      name: null,
      html: null,
      downloadFile: downloadFile
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted: async function () {
    const instruction = await this.getInstruction()
    if (instruction) {
      if (this.$refs.catalogsBaseForm) {
        this.$refs.catalogsBaseForm.id = instruction.id
        this.$refs.catalogsBaseForm.type = 'documents'
        this.$refs.catalogsBaseForm.contentType = instruction.contentType
      }
    } else {
      this.$emit('close')
    }
  },
  methods: {
    familiarizeWithInstructions: function () {
      this.loading = true

      return axiosGet({
        url: '/service/delta/employee/familiarizedWithInstructions?familiarizedWithInstructions=true&employeeId=' + this.user.employee.id + '&type=' + this.type,
        onSuccess: (response) => {
          this.$emit('close')
          return response.data
        },
        onFailure: 'Ошибка усановки параметра ознакомлен'
      }).finally(() => {
        this.loading = false
      })
    },
    getInstruction: function () {
      this.loading = true

      let label
      if (this.type == 'common') {
        label = 'instruction'
      } else if (this.type === 'polevoy') {
        label = 'polevoyInstruction'
      }

      return axiosGet({
        url: '/service/delta/document/getDocumentsByLabel?label=' + label,
        onSuccess: (response) => {
          return response.data.documents && response.data.documents[0]
        },
        onFailure: 'Ошибка загрузки инструкции'
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
